import useSWR from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import fetcher from '@/lib/swr/fetcher';
import type OpportunityConfidenceLevel from '@/types/api/OpportunityConfidenceLevel';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';

export default function useOpportunityConfidenceLevels(canFetch = true) {
  const ownerOrgId = useOwnerOrgId();
  const key = `opportunity-confidence-levels?${joinNonEmptyParams({
    ownerOrgId,
  })}`;

  return useSWR<
    { opportunityConfidenceLevels: OpportunityConfidenceLevel[] } | undefined
  >(canFetch && key, fetcher);
}
